angular.module('TetherApp').factory('accessCodeListService', [
    '$http',
    function($http) {
        let randomString = function randomString(length, chars) {
            let result = '';
            for (let i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
            return result;
        };

        let getAccessCodeLists = function (campaignId) {
            return $http.get(
                '/api/v1/access-code-list/' + campaignId,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let create = function (accessCodeList) {
            return $http.post(
                '/api/v1/access-code-list',
                accessCodeList,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let update = function (accessCodeList) {
            return $http.put(
                '/api/v1/access-code-list/' + accessCodeList.id,
                accessCodeList,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deleteAccessCodeList = function (accessCodeListId) {
            return $http.delete(
                '/api/v1/access-code-list/' + accessCodeListId,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let createPrefix = function (accessCodeListId, keyword) {
            return $http.post(
                '/api/v1/access-code-list/' + accessCodeListId + '/prefix',
                keyword,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let updatePrefix = function (accessCodeListId, keyword) {
            return $http.put(
                '/api/v1/access-code-list/' + accessCodeListId + '/prefix/' + keyword.id,
                keyword,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        let deletePrefix = function (accessCodeListId, keyword) {
            return $http.delete(
                '/api/v1/access-code-list/' + accessCodeListId + '/prefix/' + keyword.id,
                keyword,
                {
                    cache: false,
                    headers: { 'Cache-Control' : 'no-cache' }
                })
                .then(
                    function (response) {
                        return response.data;
                    }
                );
        };

        return {
            create: create,
            update: update,
            deleteAccessCodeList: deleteAccessCodeList,
            getAccessCodeLists: getAccessCodeLists,
            createPrefix: createPrefix,
            updatePrefix: updatePrefix,
            deletePrefix: deletePrefix
        }
    }
]);
